import { useTranslation } from '@framework/i18n';
import { ContentLayoutWrapper } from '@framework/ui';
import { FloatButton, FloatButtonProps, Layout } from 'antd';
import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
const { Content, Sider } = Layout;

export interface IPageLayoutBaseProps {
  children: React.ReactNode;
  /**
   * La topBarHeader deve avere l'altezza definita in theme.layoutHeaderHeight
   */
  topBarHeader?: React.ReactNode;
  fixedHeader?: boolean;
  boxedContent?: boolean;
  noPadding?: boolean;
  className?: string;
  backTopProps?: Omit<FloatButtonProps, 'target'>;
  /**
   * Per l'inserimento di una footer statica (versione del software, ecc.)
   */
  staticFooter?: React.ReactNode;
  showStaticFooter?: boolean;
  footer?: React.ReactNode;
  /** per avere un content più esteso */
  largeContent?: boolean;
}

const StyledContent = styled(Content)`
  flex: auto;
  min-height: 0;
  &.has-top-bar.fixed-header {
    margin-top: ${props => props.theme.layoutHeaderHeight}px;
  }
`;
const StyledLayout = styled(Layout)`
  min-height: 100vh;
`;
const ContentWrapper = styled.div`
  padding: 24px;
  ${down('sm')} {
    padding: 0;
  }

  &.no-padding {
    padding: 0;
  }
`;

/**
 * Layout principale dell'applicativo.
 *
 * La topBarHeader deve avere l'altezza definita in theme.layoutHeaderHeight
 *
 */
export function PageLayoutBase(props: IPageLayoutBaseProps) {
  const { t } = useTranslation();

  const hasTopBar = !!props.topBarHeader;
  const hasFooter = !!props.footer;

  return (
    <StyledLayout className={clx(props.className)}>
      {props.topBarHeader}
      <StyledContent
        as="div"
        className={clx({
          'has-top-bar': hasTopBar,
          'fixed-header': props.fixedHeader,
        })}
      >
        <ContentLayoutWrapper
          boxed={props.boxedContent}
          largeContent={props.largeContent}
        >
          <ContentWrapper className={clx({ 'no-padding': props.noPadding })}>
            {props.children}
          </ContentWrapper>
        </ContentLayoutWrapper>
      </StyledContent>
      {hasTopBar && (
        <FloatButton.BackTop
          visibilityHeight={200}
          aria-label={t(
            'layout.page-layout-base.top-bar-aria',
            'Vai all’inizio della pagina',
          )}
          {...props.backTopProps}
        />
      )}
      {/* {!hasFooter && props.staticFooter} */}
      {props.showStaticFooter && props.staticFooter}
      {props.footer}
    </StyledLayout>
  );
}
